import { useMutation } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";

const PASSWORD_RESET_SEND_PATH = "/api/auth/password-reset/send";

/**
 * Asks the API to send the branded password-reset email (ADR-0013): the API
 * mints the Firebase reset link and delivers it through our comms engine,
 * replacing Firebase's default (unbranded) template.
 *
 * The endpoint is public and ALWAYS responds 200 — it never reveals whether
 * the email is registered (no account enumeration). A 429 means the sender
 * IP hit the throttle (5/min); anything else is an infrastructure error.
 *
 * `locale` is intentionally omitted: the API resolves the email language
 * from the target user's stored locale, not the admin's UI language.
 */
async function sendReset(email: string): Promise<void> {
  await httpClient<void>(PASSWORD_RESET_SEND_PATH, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ email }),
  });
}

export function useSendPasswordReset() {
  return useMutation({
    mutationFn: sendReset,
  });
}
